// @flow
import { filter, complement, equals } from 'ramda';

import type { OrderItem } from './OrderItem.types';
import type { Complex } from './Complex.types';


type Options = {
  id: string,
  title: string,
  cost: number,
  freeCount?: number,
  amount?: number,
  incrementEnabled?: boolean,
  complex?: Complex,
  isNew?: boolean,
}

const defaultOptions = {
  freeCount: 0,
  amount: 1,
  incrementEnabled: true,
};

const createOrderItem = (options: Options): OrderItem => {
  const {
    id,
    title,
    cost,
    freeCount,
    amount,
    incrementEnabled,
    complex,
    isNew,
  } = { ...defaultOptions, ...options };

  return filter(complement(equals(undefined)), {
    id,
    title,
    cost,
    freeCount,
    amount,
    incrementEnabled,
    complex,
    isNew,
  });
};

export default createOrderItem;
